export const calculateTextBounds = (text: string, className?: string): DOMRect => {
	let elem = document.createElement("div")
	elem.style.display = "inline-block"
	if (className) elem.classList.add(className)
	elem.innerText = text
	document.body.appendChild(elem)
	const bounds = elem.getBoundingClientRect()
	document.body.removeChild(elem)
	return bounds
}